import { render, staticRenderFns } from "./CurrenciesView.vue?vue&type=template&id=e63a3cb2&scoped=true&"
import script from "./CurrenciesView.vue?vue&type=script&lang=js&"
export * from "./CurrenciesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e63a3cb2",
  null
  
)

export default component.exports